import axios from 'axios'; // https://designrevision.com/react-axios/
import axiosRetry from 'axios-retry';
import config from '~/config';
import Cookies from 'js-cookie';

const _api = axios.create({
  baseURL: config.revanceAPI.URL,
  responseType: 'json'
})

const axiosRetryOptions = {
  retries: 2,
  retryDelay: (retryCount) => {
    return retryCount * 100;
  },
}

enum Keys {
  token = 'crm_jwt'
}

export const apiController = {
  setToken: (token, expiresInSeconds) => {
    Cookies.set(Keys.token, 
      token, {
        // expires accepts value in days 
        expires: expiresInSeconds / 24 / 60 / 60 
    });
  },

  getToken: () => {
    return Cookies.get(Keys.token);
  },

  clearToken: () => {
    Cookies.remove(Keys.token);
  },

  loadToken: async () => {
    return new Promise((resolve, reject) => {
      axiosRetry(_api, axiosRetryOptions);
      _api.post(
        '/api/token',
        'username=viscira&password=8dLCR3MQ64Ho!&grant_type=password',
        {
          headers: {
            'Content-Type': 'x-www-form-urlencoded'
          },
          timeout: 10000
        }
      ).then((res) => {
        if (config.debug) { console.log('revance /api/token returned', res.data); }
        apiController.setToken(res.data.access_token, res.data.expires_in);
        resolve(res.data.access_token);
      }).catch((err) => {
        reject(err);
      })
    })
  },

  loadUser: async (sid) => {
    return new Promise((resolve, reject) => {
      if (apiController.getToken()) {
        axiosRetry(_api, axiosRetryOptions);
        _api.get(
          `/api/v1/PublicGetFullUserById/userId/${sid}`,
          {
            headers: {
              'Authorization': 'Bearer ' + apiController.getToken()
            },
            timeout: 10000
          }
        ).then((res) => {
          if (config.debug) { console.log(`revance /api/v1/PublicGetFullUserById/userId/${sid} returned`, res.data); }
          if (res.data.users.length) {
            resolve(res.data.users[0])
          } else {
            reject(res.data);
          }
        }).catch((err) => {
          reject(err);
        })
      }
      
    })
  }
}

export default apiController;


// WEBPACK FOOTER //
// ./src/utils/CRM_API.ts